import styled, { css } from 'styled-components';
import { lightBaseTheme as lightBaseThemeWithLegacy } from '../theme/index.js';

const Container = styled.label.withConfig({
    displayName: "styles__Container",
    componentId: "sc-8a3be26-0"
})`
    display: inline-flex;
    align-items: center;
    user-select: none;
`;
const HiddenInput = styled.input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "styles__HiddenInput",
    componentId: "sc-8a3be26-1"
})`
    opacity: 0;
    width: 0;
    height: 0;
    z-index: -1;
    margin: 0;
`;
const Label = styled.span.withConfig({
    displayName: "styles__Label",
    componentId: "sc-8a3be26-2"
})`
    margin-left: 16px;
    color: ${(props)=>props.theme.colors.Foreground};
    ${(props)=>css(props.theme.typography.SmallCapsHeadline)}
`;
Label.defaultProps = {
    theme: lightBaseThemeWithLegacy
};
const IconBox = styled.span.withConfig({
    displayName: "styles__IconBox",
    componentId: "sc-8a3be26-3"
})`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 3px;
    width: 24px;
    height: 24px;
    color: ${(props)=>props.theme.colors["Level 2"]};
    border: 2px solid ${(props)=>props.theme.colors["Level 2"]};
    border-radius: 4px;
    text-align: center;
    flex-shrink: 0;
    transition: border 0.2s;

    ${HiddenInput} ~ &&::before {
        content: '';
        display: inline-block;
        color: inherit;
        border: 5px solid;
        border-radius: 2px;
        opacity: 0;
        transition: all 0.2s;
    }

    ${HiddenInput}:checked ~ &&::before {
        opacity: 1;
        border: 7px solid;
        color: ${(props)=>props.accentColor ? props.accentColor : props.theme.colors["Foreground"]};
    }
`;
IconBox.defaultProps = {
    theme: lightBaseThemeWithLegacy
};

export { Container, HiddenInput, IconBox, Label };
